var map = {
	"./arrow_right.svg": 1180,
	"./bag.svg": 1182,
	"./caret_down.svg": 1183,
	"./chevron_down.svg": 1184,
	"./chevron_down_small.svg": 1185,
	"./chevron_left.svg": 1186,
	"./chevron_right.svg": 1187,
	"./chevron_up.svg": 1188,
	"./chevron_up_small.svg": 1189,
	"./close.svg": 1190,
	"./heart.svg": 1191,
	"./info-filled.svg": 1192,
	"./search-no-results.svg": 1193,
	"./search.svg": 1194,
	"./social-logo/apple.svg": 1195,
	"./social-logo/facebook.svg": 1196,
	"./social-logo/google.svg": 1197,
	"./stone-shape/asscher.svg": 1198,
	"./stone-shape/baguette.svg": 1199,
	"./stone-shape/cushion.svg": 1200,
	"./stone-shape/emerald.svg": 1201,
	"./stone-shape/heart.svg": 1202,
	"./stone-shape/marquise.svg": 1203,
	"./stone-shape/oval.svg": 1204,
	"./stone-shape/pear.svg": 1205,
	"./stone-shape/princess.svg": 1206,
	"./stone-shape/radiant.svg": 1207,
	"./stone-shape/round.svg": 1208,
	"./stone-shape/tapered-baguette.svg": 1209,
	"./stone-shape/triangle.svg": 1210,
	"./stone-shape/trillion.svg": 1211,
	"./tag.svg": 1212,
	"./truck.svg": 1213,
	"./user.svg": 1214
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1179;